import React, { forwardRef } from 'react';
import clsx from 'clsx';

import type { GridProps } from './Grid.types';

export const Grid = forwardRef<HTMLElement, GridProps>(
  (
    {
      as: Component = 'div',
      children,
      className,
      columns,
      rows,
      gap,
      templateAreas,
      templateRows,
      templateColumns,
      style,
      testId,
      theme,
    },
    ref
  ) => {
    const gridStyles = {
      '--grid-rows': rows,
      '--grid-columns': columns,
      '--grid-gap': gap,
      '--grid-template-rows': templateRows,
      '--grid-template-columns': templateColumns,
      gridTemplateAreas: templateAreas,
      ...style,
    };

    return (
      <Component
        className={clsx('hg-grid', className)}
        style={gridStyles}
        ref={ref}
        data-testid={testId}
        data-theme={theme}
      >
        {children}
      </Component>
    );
  }
);

Grid.displayName = 'Grid';
